import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import productReducer from "./slices/productSlice";
import vendorProfileReducer from "./slices/vendorProfileSlice";
import deliveryProfileReducer from "./slices/deliveryProfileSlice";
import categoryReducer from "./slices/categorySlice";
import subCategoryReducer from "./slices/subCategorySlice";
import inventoryReducer from "./slices/inventorySlice";
import bannerReducer from "./slices/bannerSlice";
import notificationReducer from "./slices/notificationSlice";
import boardReducer from "./slices/boardSlice";
import classReducer from "./slices/classSlice";
import subjectReducer from "./slices/subjectSlice";
import universityReducer from "./slices/universitySlice";
import courseReducer from "./slices/courseSlice";
import semesterReducer from "./slices/semesterSlice";
import examCategoryReducer from "./slices/examCategorySlice";
import examReducer from "./slices/examSlice";
import competitiveSubjectReducer from "./slices/competitiveSubjectSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    vendorProfile: vendorProfileReducer,
    deliveryProfiles: deliveryProfileReducer,
    categories: categoryReducer,
    subCategories: subCategoryReducer,
    inventory: inventoryReducer,
    banners: bannerReducer,
    notifications: notificationReducer,
    boards: boardReducer,
    classes: classReducer,
    subjects: subjectReducer,
    universities: universityReducer,
    courses: courseReducer,
    semesters: semesterReducer,
    examCategories: examCategoryReducer,
    exams: examReducer,
    competitiveSubjects: competitiveSubjectReducer,
  },
});

export default store;
